// extracted by mini-css-extract-plugin
module.exports = {"dashBoardSearchForm":"DashBoardSearchForm_dashBoardSearchForm__3w8Ib","header":"DashBoardSearchForm_header__g9f0K","form":"DashBoardSearchForm_form__26Qk0"};